/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export class ConvertibleCanvas {
  private readonly canvas: HTMLCanvasElement;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
  }

  getCanvas() {
    return this.canvas;
  }

  async toBlob(type: string = 'image/jpeg'): Promise<Blob> {
    return new Promise(resolve => {
      this.canvas.toBlob(file => {
        resolve(file as Blob);
      }, type);
    });
  }

  async toBlobUrl(type: string = 'image/jpeg'): Promise<string> {
    return new Promise(resolve => {
      this.canvas.toBlob(file => {
        resolve(URL.createObjectURL(file!));
      }, type);
    });
  }

  async toBase64(type: string = 'image/jpeg', quality: number = 1) {
    return this.canvas.toDataURL(type, quality);
  }
}
